import { PricingType } from 'root/clientTypes';

type Translate = (key: string) => string;

type PriceableItem = {
  pricingType?: PricingType;
  priceInfo?: {
    formattedPrice?: string | null;
  };
  priceVariants?: {
    variants?: {
      priceInfo?: {
        formattedPrice?: string | null;
      };
    }[];
  };
};

export const hasPriceVariants = (item: PriceableItem): boolean => (item.priceVariants?.variants?.length ?? 0) > 0;

export const isMarketPriceItem = (item: PriceableItem): boolean => item.pricingType === PricingType.MARKET_PRICE;

export const formatItemPrice = (item: PriceableItem, t: Translate): string => {
  if (isMarketPriceItem(item)) {
    return t('app.item.market-price');
  }

  const variantPrices = (item.priceVariants?.variants ?? [])
    .map((variant) => variant.priceInfo?.formattedPrice)
    .filter((price): price is string => !!price);

  if (variantPrices.length > 1) {
    const first = variantPrices[0];
    const last = variantPrices[variantPrices.length - 1];
    return first === last ? first : `${first} - ${last}`;
  }

  return item.priceInfo?.formattedPrice ?? '';
};
